export const rAskoFarmAddress = "0x7eb9888Fe877D4fac94519091839258038B639cE";
export const rAskoSwapRouterAddress =
  "0x06F478Bb36b95368747eb220e8ACcCb246761842";
export const rAskoSwapLibraryAddress =
  "0xa0168adcbfB068C4B1D9e0e8CBFe0235c11Ca770";
//'0x24d77F4264d74cacb17e43c02Bc1A9DDA98Ccc70'
// export const moneyMarketControl = "0x58f7ecc8dd4f4be91057d3254d27531edeafb785";
// export const moneyMarketControl = '0x455A6B6C70895F482a86C36A7093F1768Bb74d76';
export const moneyMarketControl = "0x1fB58cd056AD91237318DD525A36Ef9aEbdf0b4b";
export const uniswapOracleFactory =
  "0xB4c59852daAa898F25F80bCF8088748F8C7a242C";
export const rAskoSwapFactoryAddress =
  "0x882490A553832129070384b893A7Ec1E02B693Ff";
export const rAskoDistributionAddress =
  "0x4D730dE7Bf90e320c7d927d124211F22D0083837";
// export const rAskoCohortAddress = "0xBD8aa07D9a86E054cf1545e2A93B4DcaB277443c";
export const rAskoCohortAddress = "0x27A8902aA34d02165F712E1c5cE28Aa24CE3ea0c";
// export const testDepositAddress = "0x84248fd2327A091e8e5e5D918DbD6EF7233Adf11";
export const rAskoAddress = "0xd118f42eDbc839F7e1E85d5269A25288792c141B";
